export default __webpack_public_path__ + "static/media/ZWINNOSC.fd0d3b4e.png";